import {toInt} from '@/library/math';
import {type RouteLocation, type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const IssueTrackerIndex = () => import('../views/issue-tracker/IssueTrackerIndex.vue');

const IssueTrackerTicketAdd  = () => import('../views/issue-tracker/ticket/IssueTrackerTicketAdd.vue');
const IssueTrackerTicketEdit = () => import('../views/issue-tracker/ticket/IssueTrackerTicketEdit.vue');
const IssueTrackerTicketView = () => import('../views/issue-tracker/ticket/IssueTrackerTicketView.vue');

const IssueTrackerTicketWeeklyList = () => import('../views/issue-tracker/ticket-weekly/IssueTrackerTicketWeeklyList.vue');
const IssueTrackerTicketWeeklyEdit = () => import('../views/issue-tracker/ticket-weekly/IssueTrackerTicketWeeklyEdit.vue');
const IssueTrackerTicketWeeklyView = () => import('../views/issue-tracker/ticket-weekly/IssueTrackerTicketWeeklyView.vue');

const IssueTrackerTicketListList = () => import('../views/issue-tracker/ticket-list/IssueTrackerTicketListList.vue');
const IssueTrackerTicketListEdit = () => import('../views/issue-tracker/ticket-list/IssueTrackerTicketListEdit.vue');
const IssueTrackerTicketListView = () => import('../views/issue-tracker/ticket-list/IssueTrackerTicketListView.vue');

const IssueTrackerTicketScopeList = () => import('../views/issue-tracker/ticket-scope/IssueTrackerTicketScopeList.vue');
const IssueTrackerTicketScopeEdit = () => import('../views/issue-tracker/ticket-scope/IssueTrackerTicketScopeEdit.vue');
const IssueTrackerTicketScopeView = () => import('../views/issue-tracker/ticket-scope/IssueTrackerTicketScopeView.vue');

let meta: MetaData = {module: 'issue-tracker'};

let issueTracker: RouteRecordRaw[] = [
    {
        name: 'issue-tracker',
        path: '/issue-tracker',
        redirect: {
            name: 'issue-tracker-ticket-scope-list',
        },
    },
    {
        name: 'issue-tracker-ticket-scope-list',
        path: '/issue-tracker/ticket-scope/list',
        component: IssueTrackerTicketScopeList,
        meta,
    },
    {
        name: 'issue-tracker-ticket-scope-add',
        path: '/issue-tracker/ticket-scope/add',
        component: IssueTrackerTicketScopeEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'issue-tracker-ticket-scope-edit',
        path: '/issue-tracker/ticket-scope/edit/id/:id/:tab(scope|mail-transport|ticket|assignees-distributions|reply)?',
        component: IssueTrackerTicketScopeEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
                tab: route.params.tab || 'scope',
            };
        },
    },
    {
        name: 'issue-tracker-ticket-scope-copy',
        path: '/issue-tracker/ticket-scope/copy/copy-id/:copyId',
        component: IssueTrackerTicketScopeEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: toInt(route.params.copyId),
                tab: 'scope',
            };
        },
    },
    {
        name: 'issue-tracker-ticket-scope-view',
        path: '/issue-tracker/ticket-scope/view/id/:id/:tab(ticket|assignees|distributions|subject)?',
        component: IssueTrackerTicketScopeView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
                tab: route.params.tab || 'ticket',
            };
        },
    },
    {
        name: 'issue-tracker-ticket-list-old',
        path: '/issue-tracker/ticket/tab/:tab(overview|statistic-list|statistic-graph)?/:statisticTab(week|month|quarter|year|all)?/:back(\\d+)?',
        redirect: (route: RouteLocation) =>
        {
            return {
                name: 'issue-tracker-ticket-list',
                params: {
                    scopeId: '1',
                    tab: route.params.tab || 'overview',
                    statisticTab: route.params.statisticTab || 'week',
                    back: route.params.back || '0',
                },
            };
        },
        meta,
    },
    {
        name: 'issue-tracker-ticket-list',
        path: '/issue-tracker/ticket/scope-id/:scopeId/tab/:tab(overview|statistic-list|statistic-graph)?/:statisticTab(week|month|quarter|year|all)?/:back(\\d+)?',
        component: IssueTrackerIndex,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                scopeId: toInt(route.params.scopeId),
                tab: route.params.tab || 'overview',
                statisticTab: route.params.statisticTab || 'week',
                back: toInt(route.params.back) || 0,
            };
        },
    },
    {
        name: 'issue-tracker-ticket-add-from-scope',
        path: '/issue-tracker/ticket/add/scope-id/:scopeId',
        component: IssueTrackerTicketAdd,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                scopeId: toInt(route.params.scopeId),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-add-from-institution',
        path: '/issue-tracker/ticket/add/institution-id/:institutionId',
        component: IssueTrackerTicketAdd,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                institutionId: toInt(route.params.institutionId),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-add-from-origin',
        path: '/issue-tracker/ticket/add/origin-id/:originId',
        component: IssueTrackerTicketAdd,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                originId: toInt(route.params.originId),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-edit',
        path: '/issue-tracker/ticket/edit/id/:id',
        component: IssueTrackerTicketEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-view',
        path: '/issue-tracker/ticket/view/id/:id',
        component: IssueTrackerTicketView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-view-revert-status',
        path: '/issue-tracker/ticket/view/id/:id/revert/:revert(1)',
        component: IssueTrackerTicketView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
                revert: toInt(route.params.revert),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-weekly-list',
        path: '/issue-tracker/ticket-weekly/list',
        component: IssueTrackerTicketWeeklyList,
        meta,
    },
    {
        name: 'issue-tracker-ticket-weekly-add',
        path: '/issue-tracker/ticket-weekly/add',
        component: IssueTrackerTicketWeeklyEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'issue-tracker-ticket-weekly-edit',
        path: '/issue-tracker/ticket-weekly/edit/id/:id',
        component: IssueTrackerTicketWeeklyEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-weekly-copy',
        path: '/issue-tracker/ticket-weekly/copy/copy-id/:copyId',
        component: IssueTrackerTicketWeeklyEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: toInt(route.params.copyId),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-weekly-view',
        path: '/issue-tracker/ticket-weekly/view/id/:id',
        component: IssueTrackerTicketWeeklyView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-list-list',
        path: '/issue-tracker/ticket-list/list',
        component: IssueTrackerTicketListList,
        meta,
    },
    {
        name: 'issue-tracker-ticket-list-add',
        path: '/issue-tracker/ticket-list/add',
        component: IssueTrackerTicketListEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'issue-tracker-ticket-list-edit',
        path: '/issue-tracker/ticket-list/edit/id/:id',
        component: IssueTrackerTicketListEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-list-copy',
        path: '/issue-tracker/ticket-list/copy/copy-id/:copyId',
        component: IssueTrackerTicketListEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: toInt(route.params.copyId),
            };
        },
    },
    {
        name: 'issue-tracker-ticket-list-view',
        path: '/issue-tracker/ticket-list/view/id/:id',
        component: IssueTrackerTicketListView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        path: '/issue-tracker/:wildcard*',
        redirect: {
            name: 'issue-tracker-ticket-scope-list',
        },
    },
];

export default issueTracker;
